export default __webpack_public_path__ + "static/media/Stephen.6c4b1d28.jpg";